<mat-form-field class="chip-list">
  <mat-label
    ><mat-icon>{{ _labelIcon }}</mat-icon
    >&nbsp;&nbsp;{{ _label }}</mat-label
  >
  <mat-chip-grid #elemGrid aria-label="chip selection">
    <mat-chip-row
      class="bg-gradient-to-r dddd"
      *ngFor="let elem of elems"
      [ngClass]="{
        'ddc-gradient-light-3': !_isTag && _isLightTheme,
        'ddc-gradient-dark-3': !_isTag && _isDarkTheme,
        'ddc-gradient-paper-3': (!_isTag && _isPaperTheme) || _isDic,
        'ddc-gradient-tag-light': _isTag && (_isLightTheme || _isPaperTheme),
        'ddc-gradient-tag-dark': _isTag && _isDarkTheme,
        'ddc-gradient-fav-lng-light': _languageMode && (_isLightTheme || _isPaperTheme),
        'ddc-gradient-fav-lng-dark': _languageMode && _isDarkTheme,
      }"
      (removed)="removeElem(elem)"
    >
      {{ elem.label }}
      <button matChipRemove [attr.aria-label]="'remove ' + elem.label">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <input
    #elemInput
    placeholder="{{ _placeholder }}"
    [disabled]="_languageMode && elems.length >= 3"
    [formControl]="elemCtrl"
    [matAutocomplete]="auto"
    [matChipInputFor]="elemGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [(ngModel)]="typedOption"
  />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
    <mat-option *ngFor="let elem of filteredElems | async" [value]="elem.label">
      {{ elem.label }}
    </mat-option>
    <mat-option *ngIf="shouldShowAddNewOption() && !_isDic && !_languageMode"> {{ typedOption }} (Add New) </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="_languageMode">You can select up to 3 languages</mat-hint>
</mat-form-field>
